export const SET_STORE_CATEGORIES = 'setStoreCategories'
export const FETCH_START = 'fetchStart'
export const FETCH_END = 'fetchEnd'